<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-number">CONTENTS</p>
<p class="CON" id="pro"><a href="#/Text/Prologue"><span class="blue">Prologue</span></a></p>
<p class="CON_FIRST" id="p1"><a href="#/Text/Part1"><span class="blue">Part One</span></a></p>
<p class="CON" id="c1"><a href="#/Text/CH01"><span class="blue">Chapter One</span></a></p>
<p class="CON" id="c2"><a href="#/Text/CH02"><span class="blue">Chapter Two</span></a></p>
<p class="CON" id="c3"><a href="#/Text/CH03"><span class="blue">Chapter Three</span></a></p>
<p class="CON" id="c4"><span href="#/Text/CH04" title="Link target outside of Sample"><span class="blue">Chapter Four</span></span></p>
<p class="CON" id="c5"><span href="#/Text/CH05" title="Link target outside of Sample"><span class="blue">Chapter Five</span></span></p>
<p class="CON" id="c6"><span href="#/Text/CH06" title="Link target outside of Sample"><span class="blue">Chapter Six</span></span></p>
<p class="CON" id="c7"><span href="#/Text/CH07" title="Link target outside of Sample"><span class="blue">Chapter Seven</span></span></p>
<p class="CON" id="c8"><span href="#/Text/CH08" title="Link target outside of Sample"><span class="blue">Chapter Eight</span></span></p>
<p class="CON_FIRST" id="p2"><span href="#/Text/Part2" title="Link target outside of Sample"><span class="blue">Part Two</span></span></p>
<p class="CON" id="c9"><span href="#/Text/CH09" title="Link target outside of Sample"><span class="blue">Chapter Nine</span></span></p>
<p class="CON" id="c10"><span href="#/Text/CH10" title="Link target outside of Sample"><span class="blue">Chapter Ten</span></span></p>
<p class="CON" id="c11"><span href="#/Text/CH11" title="Link target outside of Sample"><span class="blue">Chapter Eleven</span></span></p>
<p class="CON" id="c12"><span href="#/Text/CH12" title="Link target outside of Sample"><span class="blue">Chapter Twelve</span></span></p>
<p class="CON" id="c13"><span href="#/Text/CH13" title="Link target outside of Sample"><span class="blue">Chapter Thirteen</span></span></p>
<p class="CON" id="c14"><span href="#/Text/CH14" title="Link target outside of Sample"><span class="blue">Chapter Fourteen</span></span></p>
<p class="CON" id="c15"><span href="#/Text/CH15" title="Link target outside of Sample"><span class="blue">Chapter Fifteen</span></span></p>
<p class="CON" id="c16"><span href="#/Text/CH16" title="Link target outside of Sample"><span class="blue">Chapter Sixteen</span></span></p>
<p class="CON_FIRST" id="p3"><span href="#/Text/Part3" title="Link target outside of Sample"><span class="blue">Part Three</span></span></p>
<p class="CON" id="c17"><span href="#/Text/CH17" title="Link target outside of Sample"><span class="blue">Chapter Seventeen</span></span></p>
<p class="CON" id="c18"><span href="#/Text/CH18" title="Link target outside of Sample"><span class="blue">Chapter Eighteen</span></span></p>
<p class="CON" id="c19"><span href="#/Text/CH19" title="Link target outside of Sample"><span class="blue">Chapter Nineteen</span></span></p>
<p class="CON_FIRST" id="epi"><span href="#/Text/Epilogue" title="Link target outside of Sample"><span class="blue">Epilogue</span></span></p>
<p class="CON" id="ack"><span href="#/Text/Acknowledgements" title="Link target outside of Sample"><span class="blue">Acknowledgements</span></span></p>
<p class="CON" id="ata"><span href="#/Text/ATA" title="Link target outside of Sample"><span class="blue">About the Author</span></span></p>
<p class="CON" id="cred"><span href="#/Text/Credits" title="Link target outside of Sample"><span class="blue">Credits</span></span></p>
<p class="CON" id="cop"><span href="#/Text/Copyright" title="Link target outside of Sample"><span class="blue">Copyright</span></span></p>
<p class="CON" id="atp"><span href="#/Text/ATP" title="Link target outside of Sample"><span class="blue">About the Publisher</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0148f0b4